import { APIParser } from "./api-parser";
import { NEW_API_URL } from "./api-client";
import {
  createFetchDeleteOptions,
  createFetchGetOptions,
  createFetchPostOptions,
  createFetchPutOptions,
  createURLWithQueryParams,
} from "./api-util";
import triyoAPI from "./triyo.js";
import { config } from "../../util/axios-config.js";

const baseTaskTypesURL = `${NEW_API_URL}task-types/`;

// TaskTypeDto: {
//      Id: int
//      Type: string
//  }

export async function getTaskTypes(type) {
  const url = createURLWithQueryParams(`${baseTaskTypesURL}`, { type });
  const response = await fetch(url, createFetchGetOptions());
  return APIParser(response);
}

// TAD-5783 -- Multi-admin Task Type Access.
// Admin-only list endpoint. Returns WorkItemTypeAdminDto[] (each row carries
// SubDepartments[] and a server-computed IsEditable flag). The server throws
// UserIsNotAuthorized for non-admin callers, so this should only be invoked
// from the Admin > Task Types table.
export async function getAdminTaskTypes(type) {
  const axiosConfig = { ...config() };
  if (type != null) {
    axiosConfig.params = { type };
  }
  const { data } = await triyoAPI.get("/task-types/admin", axiosConfig);
  return data;
}

// only Type is required
export async function addTaskType(taskTypeDto) {
  const response = await fetch(
    `${baseTaskTypesURL}`,
    createFetchPostOptions(taskTypeDto)
  );
  return APIParser(response);
}

// only Id and Type are required
export async function updateTaskType(taskTypeDto) {
  const url = createURLWithQueryParams(`${baseTaskTypesURL}${taskTypeDto.Id}`);
  const response = await fetch(url, createFetchPutOptions(taskTypeDto));
  return APIParser(response);
}

export async function deleteTaskType(id) {
  const url = createURLWithQueryParams(`${baseTaskTypesURL}${id}`);
  const response = await fetch(url, createFetchDeleteOptions());
  return response.ok ? response : Promise.reject(response);
}

//New Component Api's
export const EditTaskTypeAPI = (data) => {
  return triyoAPI.put(`/task-types/${data.Id}`, data, config("PUT"));
};

export const CreateTaskTypeAPI = (data) => {
  return triyoAPI.post(`/task-types`, data, config("POST"));
};

export const GetTaskTypesSortedByName = () => {
  return triyoAPI.get("/task-types/GetTaskTypesSortedByName", config());
};

export const GetTaskTypesForTask = () => {
  return triyoAPI.get("/task-types", config());
};
export const GetDefaultTaskTypeForTask = () => {
  return triyoAPI.get("/task-types/default-task-type", config());
};

export const GetWorkflowFormFieldProperties = (formId, type) => {
  return triyoAPI.get(
    `/workflow/formfieldproperties/${formId}/${type}`,
    config()
  );
};

export const UpdateWorkflowFormFieldProperties = (formId, data, type) => {
  return triyoAPI.post(
    `/workflow/formfieldproperties/${formId}/${type}`,
    data,
    config()
  );
};

export const GetNewTaskTypeSettings = (id) => {
  return triyoAPI.get(`/settings/GetNewTaskTypeSettings?Id=${id}`, config());
};

export const GetTaskTypeStatuses = (taskTypeId) => {
  return triyoAPI.get(`/task-types/${taskTypeId}/statuses`, config());
};

export const GetTaskTypeStatus = (statusId) => {
  return triyoAPI.get(`/task-types/statuses/${statusId}`, config());
};

export const AddTaskTypeStatus = (taskTypeId, dto) => {
  return triyoAPI.post(`/task-types/${taskTypeId}/statuses`, dto, config("POST"));
};

export const UpdateTaskTypeStatus = (statusId, dto) => {
  return triyoAPI.put(`/task-types/statuses/${statusId}`, dto, config("PUT"));
};

export const DeleteTaskTypeStatus = (statusId) => {
  return triyoAPI.delete(`/task-types/statuses/${statusId}`, config("DELETE"));
};

export const GetAllStatusBadgeColors = () => {
  return triyoAPI.get(`/task-types/statuses/colors`, config());
};

export const GetStatusBadgeColor = (name) => {
  return triyoAPI.get(`/task-types/statuses/colors/${name}`, config());
};
